const Input = {
  parts: ['field'],
  variants: {
    grayed: {
      field: {
        bg: 'gray.50',
        border: 'none',
        borderRadius: '8px',
        color: 'gray.800',
        height: '40px',
        px: 4,
        py: 2,
        _focus: {
          borderColor: 'black',
        },
        _hover: {
          bg: 'gray.50',
        },
      },
    },
  },
  defaultProps: {
    variant: 'grayed',
  },
};

export default Input;
